import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { LoginCredentials, RegisterData } from '../types';

export function useAuth() {
  const navigate = useNavigate();
  const {
    usuario,
    token,
    isLoading,
    isAuthenticated,
    login: storeLogin,
    register: storeRegister,
    logout: storeLogout,
    loadUser,
    updateUser,
  } = useAuthStore();

  // Load user on mount if token exists
  useEffect(() => {
    if (token && !usuario) {
      loadUser();
    }
  }, [token, usuario, loadUser]);

  const login = useCallback(async (credentials: LoginCredentials, redirectTo?: string) => {
    const success = await storeLogin(credentials);
    if (success) {
      navigate(redirectTo || '/');
    }
    return success;
  }, [storeLogin, navigate]);

  const register = useCallback(async (data: RegisterData, redirectTo?: string) => {
    const success = await storeRegister(data);
    if (success) {
      navigate(redirectTo || '/');
    }
    return success;
  }, [storeRegister, navigate]);

  const logout = useCallback(async () => {
    await storeLogout();
    navigate('/');
  }, [storeLogout, navigate]);

  const isAdmin = usuario?.tipo === 'admin';
  const isVendedor = usuario?.tipo === 'vendedor' || usuario?.tipo === 'admin';

  return {
    usuario,
    token,
    isLoading,
    isAuthenticated,
    isAdmin,
    isVendedor,
    login,
    register,
    logout,
    updateUser,
    loadUser,
  };
}

export default useAuth;
